const MenuProfessor = [
    {
        heading: 'Menu Professor',
        translate: 'sidebar.heading.HEADER.Professor'
    },
    {
        name: 'Escolas',
        translate: 'menu.Escolas',
        icon: 'fa fa-cogs',
        submenu: [{
            name: 'Escolas',
            translate: 'menu.Escolas',
            path: '/inicial'
        },
        {
            name: 'Nova Escola',
            path: '/novaescola',
            translate: 'menu.NovaEscola'
        }
    ]
    },
    {
        name: 'Dados Próprios',
        translate: 'menu.DadosProprios',
        icon: 'fa fa-user',
        submenu: [{
            name: 'Meus Dados',
            translate: 'menu.MeusDados',
            path: '/dadospessoaisprof'
        },{
            translate: 'menu.TrocarSenha',
            name: 'Trocar Senha',
            path: '/trocarsenha'
        }]
    },
];

export default MenuProfessor;
